/**
 * Leaving a game, behind two taps.
 *
 * One tap arms it and the label changes; a second confirms. It reverts on its own
 * after a few seconds, so a stray tap on a phone never drops somebody out of a game
 * mid-round. scope.md §6.4.
 */

import { useEffect, useState } from 'react';
import { useT } from '../i18n.js';

export const ARM_MS = 4000;

export function LeaveButton({ onLeave }: { onLeave: () => void }) {
  const t = useT();
  const [armed, setArmed] = useState(false);

  useEffect(() => {
    if (!armed) return;
    const handle = setTimeout(() => setArmed(false), ARM_MS);
    return () => clearTimeout(handle);
  }, [armed]);

  return (
    <button
      type="button"
      data-testid="leave-button"
      data-armed={armed}
      onClick={() => (armed ? onLeave() : setArmed(true))}
      className={[
        'rounded-full px-3 text-xs font-bold',
        armed ? 'bg-coral text-ink' : 'bg-white/10 text-bone/70',
      ].join(' ')}
    >
      {armed ? t('common.reallyLeave') : t('common.leave')}
    </button>
  );
}
